import React from "react";
import "./Menu.css";
import { Link, useLocation } from "react-router-dom";
import ButtonLogin from "shared/components/buttons/ButtonLogin.js";
import ButtonLogo from "shared/components/buttons/ButtonLogo.js";

interface MenuProps {}

const Menu: React.FC<MenuProps> = (props) => {
  const location = useLocation();

  const getMenuLabel = (text, cl) => {
    return (
      <span
        className={
          "text-center d-none d-lg-block text-capitalize w-100 " +
          "lh-1 py-0 py-lg-3 pt-lg-1 pb-lg-1 px-1 px-lg-0 " +
          cl
        }
      >
        {text}
      </span>
    );
  };

  return (
    <nav id="Menu" className="navbar h-100 flex-lg-column">
      <div className="d-flex flex-grow-0 align-items-center">
        <ButtonLogo />
      </div>

      <Link to="/search" className={"nav-link nav-link-search py-2 px-3"}>
        <div className="py-lg-1 px-2 px-lg-1">
          <i className="bi bi-search"></i>
        </div>
      </Link>

      <div className="d-flex d-sm-none flex-grow-0">
        <div className="nav-item align-content-center">
          <ButtonLogin
            className={"nav-link nav-link-login ps-lg-0 ms-lg-0"}
            flowUser={props.flowUser}
            assistantUser={props.assistantUser}
            logout={props.logout}
            redirectToHq={true}
            content={
              <div className="Menu-login d-inline-block align-items-center text-center" title="Login">
                <div className="text-center">
                  <i className="bi bi-person lh-1 px-1"></i>
                  <div className="d-block w-100 lh-1">LOGIN</div>
                </div>
              </div>
            }
          />
        </div>
      </div>

      <div className="d-flex flex-grow-1 align-items-lg-center justify-content-center justify-content-sm-start">
        <ul className="navbar-nav flex-row flex-lg-column h4">
          <li className="nav-item">
            <Link
              to="/opponent-finder"
              className={"nav-link" + (location.pathname.startsWith("/opponent-finder") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                {location.pathname.startsWith("/opponent-finder") ? (
                  <i className="bi bi-binoculars-fill"></i>
                ) : (
                  <i className="bi bi-binoculars"></i>
                )}
              </div>
              {getMenuLabel("Opponent finder", "d-none d-xl-inline")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/formation-meta"
              className={"nav-link" + (location.pathname.startsWith("/formation-meta") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                {location.pathname.startsWith("/formation-meta") ? (
                  <i className="bi bi-grid-3x3-gap-fill"></i>
                ) : (
                  <i className="bi bi-grid-3x3-gap"></i>
                )}
              </div>
              {getMenuLabel("Formation meta", "d-none d-xl-inline")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/divisions"
              className={"nav-link" + (location.pathname.startsWith("/divisions") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                {location.pathname.startsWith("/divisions") ? (
                  <i className="bi bi-triangle-fill"></i>
                ) : (
                  <i className="bi bi-triangle"></i>
                )}
              </div>
              {getMenuLabel("Division Strength", "d-none d-xl-inline")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/match-planner"
              className={"nav-link" + (location.pathname.startsWith("/match-planner") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                {location.pathname.startsWith("/match-planner") ? (
                  <i className="bi bi-calendar-week-fill"></i>
                ) : (
                  <i className="bi bi-calendar-week"></i>
                )}
              </div>
              {getMenuLabel("Match planner", "d-none d-xl-inline")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/squad-builder"
              className={"nav-link" + (location.pathname.startsWith("/squad-builder") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                <i className="bi bi-person-rolodex"></i>
              </div>
              {getMenuLabel("Squad builder", "d-none d-xl-inline")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/tactic-analysis"
              className={"nav-link" + (location.pathname.startsWith("/tactic-analysis") ? " active" : "")}
            >
              <div className="px-2 px-lg-0">
                {location.pathname.startsWith("/tactic-analysis") ? (
                  <i className="bi bi-clipboard2-pulse-fill"></i>
                ) : (
                  <i className="bi bi-clipboard2-pulse"></i>
                )}
              </div>
              {getMenuLabel("Tactic analysis", "d-none d-xl-inline")}
            </Link>
          </li>
        </ul>
      </div>

      <div className="d-none d-sm-flex flex-grow-0">
        <div className="nav-item align-content-center">
          <ButtonLogin
            className={"nav-link nav-link-login ps-lg-0 ms-lg-0"}
            flowUser={props.flowUser}
            assistantUser={props.assistantUser}
            logout={props.logout}
            redirectToHq={true}
            content={
              <div className="Menu-login d-inline-block align-items-center text-center" title="Login">
                <div className="text-center">
                  <i className="bi bi-box-arrow-in-right lh-1 px-1"></i>
                  <div className="login-label d-block w-100 lh-1">LOGIN</div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    </nav>
  );
};

export default Menu;
